/**
 * Gli impegni di oggi: calendario aziendale Google piu' prossime azioni sui
 * lead, dallo stesso magazzino che usa la pagina Calendario. Si rileggono
 * ogni 5 minuti per restare allineati.
 *
 * Spostato qui dal vecchio riquadro DailyAppointments della pagina iniziale.
 * In piu' distingue "calendario non collegato" da "nessun impegno": prima un
 * calendario scollegato sembrava una giornata libera.
 */

import { useEffect, useMemo } from 'react';
import { endOfDay, startOfDay } from 'date-fns';
import { useGoogleCalendarStore } from '../store/useGoogleCalendarStore';
import type { GoogleEvent } from '../types/calendar.types';

const OGNI_CINQUE_MINUTI = 5 * 60_000;

export interface ImpegniOggi {
  eventi: GoogleEvent[];
  prossimo: GoogleEvent | undefined;
  caricamento: boolean;
  configurato: boolean;
  collegato: boolean;
  errore: string | null;
  ricarica: () => void;
}

export function useImpegniOggi(): ImpegniOggi {
  const fetchEvents = useGoogleCalendarStore((s) => s.fetchEvents);
  const events = useGoogleCalendarStore((s) => s.events);
  const configured = useGoogleCalendarStore((s) => s.configured);
  const collegato = useGoogleCalendarStore((s) => s.collegato);
  const loading = useGoogleCalendarStore((s) => s.loading);
  const error = useGoogleCalendarStore((s) => s.error);

  const ricarica = useMemo(() => () => {
    const adesso = new Date();
    void fetchEvents(startOfDay(adesso), endOfDay(adesso));
  }, [fetchEvents]);

  useEffect(() => {
    ricarica();
    const giro = setInterval(ricarica, OGNI_CINQUE_MINUTI);
    return () => clearInterval(giro);
  }, [ricarica]);

  const eventi = useMemo(() => {
    const adesso = new Date();
    const inizio = startOfDay(adesso);
    const fine = endOfDay(adesso);
    return events
      .filter((ev) => {
        const d = new Date(ev.startDate);
        return d >= inizio && d <= fine;
      })
      .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  }, [events]);

  const prossimo = eventi.find((ev) => new Date(ev.startDate) > new Date());

  return {
    eventi,
    prossimo,
    caricamento: loading && eventi.length === 0,
    configurato: configured,
    collegato,
    errore: error,
    ricarica,
  };
}
